import Swiper from 'swiper/bundle';

const rsCarousel = {
    init: (carousels) => {
        carousels.forEach(carousel => {
            const swiperOptions = {};
            const loop = carousel.dataset.loop;
            const autoplay = carousel.dataset.autoplay;
            const pagination = carousel.dataset.pagination;
            const effect = carousel.dataset.effect;

            swiperOptions.slidesPerView = 1;

            if (loop) {
                swiperOptions.loop = true;
            }

            if (autoplay) {
                swiperOptions.autoplay = autoplay;
            }

            if (pagination) {
                swiperOptions.pagination = {
                    el: '.swiper-pagination',
                    clickable: true,
                };
            }

            if (effect) {
                swiperOptions.effect = 'fade';
            }

            const swiper = new Swiper(`#${carousel.getAttribute('id')}`, swiperOptions);

            swiper.on('slideChange', function() {
                const currentSlide = swiper.realIndex;
                const currentAttr = '[data-swiper-slide-index="' + currentSlide + '"]';
                const currentVideo = currentAttr + ' video';
                jQuery('.swiper-slide video').each(function() {
                    jQuery(this).get(0).pause();
                });
                jQuery('.swiper-slide .play-active').each(function() {
                    jQuery(this).removeClass('play-active');
                    jQuery(this).addClass('pause-active');
                });
                if (jQuery(currentVideo).length) {
                    jQuery(currentAttr + ':not(.swiper-slide-duplicate) video').get(0).play();
                }
            });
            jQuery('.swiper-wrapper').on('click', '.rs-hero-carousel__play-pause.pause-active', function() {
                jQuery(this).siblings('.rs-video').children('video').get(0).pause();
                jQuery(this).removeClass('pause-active');
                jQuery(this).addClass('play-active');
            });
            jQuery('.swiper-wrapper').on('click', '.rs-hero-carousel__play-pause.play-active', function() {
                jQuery(this).siblings('.rs-video').children('video').get(0).play();
                jQuery(this).removeClass('play-active');
                jQuery(this).addClass('pause-active');
            });
        });
    },
};

export default rsCarousel;
